export default "__VITE_ASSET__5aba7d20__"